import { useCallback, useContext, useMemo, useRef } from "react";
import { StyleSheet, View } from "react-native";
import { useTheme } from "react-native-elements";
import {
  EquipmentSlot,
  loadEquipmentLoadoutFromPosition,
} from "../../backend/items/Equipment";
import { PlayerContext } from "../../backend/PlayerContext";
import { Button } from "../utility/Button";
import { GameIcon } from "../utility/icons/GameIcon";
import { getPrimaryButtonTextColor } from "../utility/Miscellaneous";
import { Text } from "../utility/Text";

export function EquipmentSetButtons() {
  const playerContext = useContext(PlayerContext);
  const playerContextRef = useRef(playerContext);
  playerContextRef.current = playerContext;

  const setNumber = playerContext.lastEquipmentLoadoutModified + 1;

  const equipmentSetButtonCallback = useCallback((index: number) => {
    playerContextRef.current.apply((state) =>
      loadEquipmentLoadoutFromPosition(state, index),
    );
  }, []);

  const theme = useTheme();

  const equipmentSetButtons = useMemo(() => {
    return [0, 1, 2, 3].map((i) => {
      const equipmentSet = playerContext.equipmentLoadouts?.[i];
      const icons = [];
      for (let slot of Object.values(EquipmentSlot)) {
        const itemOccurrence = equipmentSet?.equipment?.[slot];
        if (itemOccurrence != null) {
          const icon = (
            <GameIcon key={slot} icon={itemOccurrence.itemId} small={true} />
          );
          icons.push(icon);
        } else {
          icons.push(<View key={slot} style={styles.emptyIcon} />);
        }
      }

      return (
        <View key={i} style={styles.buttonContainer}>
          <Button
            containerStyle={styles.setButton}
            title={
              <Text
                style={[
                  styles.smallButtonTitle,
                  {
                    color: getPrimaryButtonTextColor(
                      theme.theme,
                      setNumber == i + 1,
                    ),
                  },
                ]}
                doNotScaleFonts={true}
              >{`Set ${i + 1}`}</Text>
            }
            disabled={setNumber == i + 1}
            onPress={equipmentSetButtonCallback.bind(null, i)}
          />
          <View style={styles.iconsContainer}>{icons}</View>
        </View>
      );
    });
  }, [
    JSON.stringify(playerContext.equipmentLoadouts),
    equipmentSetButtonCallback,
    setNumber,
    theme,
  ]);

  return (
    <View style={styles.equipmentSetButtonsRow}>
      <View style={styles.setText}>
        <Text>Equip set: {setNumber}</Text>
      </View>
      {equipmentSetButtons}
    </View>
  );
}

const styles = StyleSheet.create({
  equipmentSetButtonsRow: {
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
  },
  setButton: {
    width: 52,
  },
  setText: {
    marginRight: 8,
  },
  smallButtonTitle: {
    fontSize: 12,
  },
  iconsContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: 16,
    width: 48,
    marginTop: 2,
  },
  emptyIcon: {
    width: 16,
  },
  buttonContainer: {
    marginLeft: 8,
    alignItems: "center",
    width: 52,
  },
});
